import { Common } from "@secondcloset/types";

import { getAPIFromDomain } from "../../lib/api";
import UrlBuilder from "../../lib/UrlBuilder";
import { AxiosResponse } from "axios";

export interface FetchUserQuery {
  organization_id?: string;
  per_page?: number;
  page?: number;
  q?: string;
  disabled?: boolean;
}

export const fetchUsers = async (query: FetchUserQuery): Promise<Common.User[]> => {
  const api = getAPIFromDomain();
  const urlBuilder = new UrlBuilder("/users");
  const url = urlBuilder.applyQueryStringFromObject(query);
  const response = await api.get(url);
  return response.data;
};

interface UpdateUserParams {
  userID: string;
  body: unknown;
}
export const updateUser = async ({ userID, body }: UpdateUserParams): Promise<Common.User> => {
  const api = getAPIFromDomain("accounts");
  const response = await api.put(`/users/${userID}`, body);
  return response.data;
};

export interface BatchUpdateUsersParams {
  userIDs: string[];
  disabled?: boolean;
  subrole?: string;
  role_id?: string;
}

export const batchUpdateUsers = async ({
  userIDs,
  disabled,
  subrole,
  role_id,
}: BatchUpdateUsersParams): Promise<Common.User[]> => {
  const api = getAPIFromDomain("accounts");
  const userUpdates: Record<string, unknown> = {};

  if (disabled !== undefined) userUpdates.disabled = disabled;
  if (subrole !== undefined) userUpdates.subrole = subrole;
  if (role_id !== undefined) userUpdates.role_id = role_id;
  console.log("userIDs:", userIDs);
  const body = {
    user_ids: userIDs,
    attributes: userUpdates,
  };
  const response = await api.post("/users/bulk_update", body);
  return response.data;
};

export interface BatchPasswordResetParams {
  userIDs: string[];
}

export const batchPasswordReset = async ({ userIDs }: BatchPasswordResetParams): Promise<Common.User[]> => {
  const api = getAPIFromDomain("accounts");

  const body = {
    user_ids: userIDs,
  };
  const response = await api.post("/users/bulk_password_reset", body);
  return response.data;
};

export interface InviteDriversParams {
  role_id: string;
  fleet_operator: string;
  emails: string[];
}
export const inviteDrivers = async (body: InviteDriversParams): Promise<AxiosResponse<Common.User[]>> => {
  const api = getAPIFromDomain("accounts");
  const response = await api.post("/users/invite_drivers", body);
  return response.data;
};
